import React, { useEffect, useState } from "react";
import SlotItem from "./SlotItem";
import {
  subscribeSlots,
  fetchSlots,
  selectSlot,
} from "../../../../../../utils/odsArchitecture/odsSlotService";
import { manualOrderRefresh } from "../../../../../../utils/odsArchitecture/orderPollingService";
import SkeletonLoader from "../../../../delivery/components/SkeletonLoader";

const SlotList = ({ onSlotSelect }) => {
  const [slotList, setSlotList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Subscribe to slot state — loading driven by service's isFetching flag
  useEffect(() => {
    const unsubscribe = subscribeSlots((state) => {
      setSlotList(state?.slotList || []);
      setIsLoading(state?.isFetching ?? false);
    });
    return () => unsubscribe();
  }, []);

  // Fetch slots once on mount
  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    const locId = localStorage.getItem("locId");
    fetchSlots({ date: new Date(), orgId, locId });
  }, []);

  if (isLoading) {
    return (
      <div className="board-slots-container">
        <SkeletonLoader type="single-item" />
      </div>
    );
  }

  if (!slotList?.length) {
    return (
      <div className="board-slots-container">
        <div className="no-slot">No slots available</div>
      </div>
    );
  }

  return (
    <>
      {slotList?.map((slot) => {
        let label = null;

        if (slot?.isAll) label = "All Orders";
        if (slot?.instant) label = "Instant Delivery";

        return (
          <SlotItem
            key={slot?.slotId}
            startTime={slot?.startTime}
            endTime={slot?.endTime}
            format="12h"
            backgroundColor={slot?.selected ? "var(--blue-b0)" : "var(--surface-white)"}
            textColor={slot?.selected ? "var(--surface-white)" : "var(--blue-b0)"}
            selected={slot?.selected}
            label={label}
            notificationCount={slot?.createdCount}
            onClick={() => {
              selectSlot(slot?.slotId);
              if (onSlotSelect) {
                onSlotSelect(slot?.slotId);
              } else {
                manualOrderRefresh();
              }
            }}
          />
        );
      })}
    </>
  );
};

export default SlotList;
